<template>
  <div>
    <nav v-if="!isNew" class="breadcrumb is-small" aria-label="breadcrumbs">
      <ul>
        <li>
          <router-link to="/companies">
            一覧
          </router-link>
        </li>
        <li v-if="company_id">
          <router-link :to="{ name: 'CompaniesDetail', params: { company_id: company_id }}">
            会社詳細343434
          </router-link>
        </li>
        <li class="is-active">
          <a href="#" aria-current="page">会社編集</a>
        </li>
      </ul>
    </nav>

    <h1 v-if="isNew" class="title is-4 is-spaced">
      施工新規登録
    </h1>
    <h1 v-else class="title is-4 is-spaced">
      施工編集
    </h1>

    <div class="column">
      <div class="field is-horizontal">
        <div class="field-label">
          <label class="label">施工主名</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <b-input v-model="company_name" required />
            </div>
            <p v-if="errors.company_name" class="help is-danger">
              {{ errors.company_name }}
            </p>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label">
          <label class="label">施工主名ふりがな</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <b-input v-model="company_name_kana" />
            </div>
            <p v-if="errors.company_name_kana" class="help is-danger">
              {{ errors.company_name_kana }}
            </p>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label">
          <label class="label">業者名</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <b-input v-model="advertising_agency" />
            </div>
            <p v-if="errors.advertising_agency" class="help is-danger">
              {{ errors.advertising_agency }}
            </p>
          </div>
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-label">
          <!-- Structure type (1) -->
          <label class="label">構造種別（1）</label>
        </div>
        <!-- <div class="field-body">
          <div class="field">
            <div class="control">
              <b-input v-model="advertising_agency" />
            </div>
            <p v-if="errors.advertising_agency" class="help is-danger">
              {{ errors.advertising_agency }}
            </p>
          </div>
        </div> -->

        <div class="field-body">
          <div class="field">
            <div class="control">
              <multiselect
                v-model="selectedInsdustryType"
                track-by="key"
                label="value"
                :options="tagBox"
                :multiple="false"
                placeholder=""
                select-label="選択する"
                deselect-label="外す"
                selected-label="選択中"
                :custom-label="customLabel"
              />
            </div>
            <p v-if="errors.industry_type" class="help is-danger">
              {{ errors.industry_type }}
            </p>
          </div>
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-label">
          <!-- Structure type (2) -->
          <label class="label">構造種別（2）</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <multiselect
                v-model="selectedTags"
                track-by="key"
                label="value"
                :options="tagBox"
                :multiple="true"
                placeholder=""
                select-label="選択する"
                deselect-label="外す"
                selected-label="選択中"
                :custom-label="customLabel"
              />
            </div>
            <p v-if="errors.tags" class="help is-danger">
              {{ errors.tags }}
            </p>
          </div>
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-label">
          <label class="label">URL</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <b-input v-model="url" />
            </div>
            <p v-if="errors.url" class="help is-danger">
              {{ errors.url }}
            </p>
          </div>
        </div>
      </div>

      <hr>

      <div v-for="(shop, index) in shops" :key="index" class="shop_block">
        <!-- <div class="field is-horizontal">
          <div class="field-label">
            <label id="add-shop-block" class="label" @click="addShopBlock">
              <b-icon icon="plus-circle-outline" size="is-small" />
              店舗名
            </label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <b-input v-model="shop.shop_name" />
              </div>
              <p v-if="errors.shop_name" class="help is-danger">
                {{ errors.shop_name }}
              </p>
            </div>
          </div>
        </div> -->

        <!-- <div class="field is-horizontal">
          <div class="field-label">
            <label class="label">
              店舗名かな
            </label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <b-input v-model="shop.shop_name_kana" />
              </div>
              <p v-if="errors.shop_name_kana" class="help is-danger">
                {{ errors.shop_name_kana }}
              </p>
            </div>
          </div>
        </div> -->

        <div class="field is-horizontal">
          <div class="field-label">
            <label id="add-shop-block" class="label" @click="addShopBlock">
              <b-icon icon="plus-circle-outline" size="is-small" />
              担当者
            </label>
            <!-- <label class="label">担当者</label> -->
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <b-input v-model="shop.charge" />
              </div>
              <p v-if="errors.charge" class="help is-danger">
                {{ errors.charge }}
              </p>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label">
            <label class="label">担当者ふりがな</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <b-input v-model="shop.charge_kana" />
              </div>
              <p v-if="errors.charge_kana" class="help is-danger">
                {{ errors.charge_kana }}
              </p>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label">
            <label class="label">住所</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <b-input v-model="shop.address" />
              </div>
              <p v-if="errors.address" class="help is-danger">
                {{ errors.address }}
              </p>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label">
            <label class="label">
              電話番号
            </label>
          </div>
          <div class="field-body">
            <div v-for="(row, idx) in shop.phone_numbers" :key="idx" class="field">
              <div class="control">
                <b-input v-model="row.phone_number" @blur="checkPhoneNumber(shop.shop_id, index, idx)" />
              </div>
              <p v-if="errors.phone_number" class="help is-danger">
                {{ errors.phone_number }}
              </p>
            </div>
            <div id="add-phone-number-input" @click="addPhoneNumberInput(shop)">
              <b-icon icon="plus-circle-outline" size="is-small" />
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label">
            <label class="label">メールアドレス</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <b-input v-model="shop.email_address" />
              </div>
              <p v-if="errors.email_address" class="help is-danger">
                {{ errors.email_address }}
              </p>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label">
            <label class="label">状態</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <b-select v-model="shop.state" required>
                  <option v-for="(value, idx) in states" :key="idx" :value="idx">
                    {{ value }}
                  </option>
                </b-select>
              </div>
              <p v-if="errors.state" class="help is-danger">
                {{ errors.state }}
              </p>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label">
            <label class="label">見込み</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <b-select v-model="shop.likelihood" required>
                  <option v-for="(value, idx) in likelihoods" :key="idx" :value="idx">
                    {{ value }}
                  </option>
                </b-select>
              </div>
              <p v-if="errors.likelihood" class="help is-danger">
                {{ errors.likelihood }}
              </p>
            </div>
          </div>
        </div>
        <hr>
      </div>
    </div>


    <div class="field is-horizontal">
      <div class="field-label">
        <label class="label">備考</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control">
            <b-input v-model="note" type="textarea" maxlength="999" />
          </div>
          <p v-if="errors.note" class="help is-danger">
            {{ errors.note }}
          </p>
        </div>
      </div>
    </div>

    <div class="control has-text-centered">
      <button type="button" class="button is-primary" @click="register">
        登録
      </button>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  name: 'CompaniesRegister',
  components: {Multiselect},
  data() {
    return {
      company_id: null,
      isNew: null,
      errors: {},
      company_name: null,
      company_name_kana: null,
      industry_type: null,
      advertising_agency: null,
      url: null,
      selectedTags: [],
      selectedInsdustryType: null,
      note: null,
      shops: [
        {
          shop_id: null,
          shop_name: null,
          shop_name_kana: null,
          charge: null,
          charge_kana: null,
          address: null,
          phone_numbers: [{phone_number: null}],
          email_address: null,
          state: 10,
        }],
      tagBox: [],
      tags: [],
      states: [],
      likelihoods: [],
    }
  },
  watch: {
    '$route'() {
      this.setData()
    },
    shops: function (array) {
      if (array.length === 0) {
        this.addShopBlock()
      }
    },
  },
  mounted() {
    this.setData()
  },
  methods: {
    setData() {
      this.setInit()
      if (this.$route.params.company_id === 'new') {
        this.company_id = null
        this.isNew = true
      } else {
        this.company_id = Number(this.$route.params.company_id)
        this.isNew = false
      }
      this.getCompany()
    },
    setInit() {
      this.company_name = null
      this.company_name_kana = null
      this.industry_type = null
      this.advertising_agency = null
      this.url = null
      this.selectedTags = []
      this.selectedInsdustryType = null
      this.note = null
      this.shops = [
        {
          shop_id: null,
          shop_name: null,
          charge: null,
          charge_kana: null,
          address: null,
          phone_numbers: [{phone_number: null}],
          email_address: null,
          state: 10,
          likelihood: 10,
        }]
      this.errors = {}
    },
    getCompany() {
      this.$http.get('/companies/' + this.$route.params.company_id + '/register').then(response => {
        this.states = response.data.states
        this.likelihoods = response.data.likelihoods
        this.tagBox = response.data.tagBox
        this.tags = response.data.tags
        if (!this.isNew) {
          this.company_name = response.data.company.company_name
          this.company_name_kana = response.data.company.company_name_kana
          this.industry_type = response.data.company.industry_type
          this.advertising_agency = response.data.company.advertising_agency
          this.url = response.data.company.url
          this.selectedTags = response.data.selectedTags
          this.shops = response.data.shops
          let phone_numbers = response.data.phone_numbers
          this.note = response.data.company.note
          this.tagBox.forEach((item) => {
            if (item.value === this.industry_type) {
              this.selectedInsdustryType = item
            }
          })
          this.shops.forEach((row) => {
            row.phone_numbers = phone_numbers[row.shop_id]
            if (!row.phone_numbers) {
              row.phone_numbers = []
              this.addPhoneNumberInput(row)
            }
          })
        }
      })
    },
    addPhoneNumberInput(shop_index) {
      shop_index = this.shops.indexOf(shop_index)
      this.shops[shop_index].phone_numbers.push({phone_number: null})
      this.shops.push()
    },
    addShopBlock() {
      this.shops.push({
        shop_id: null,
        shop_name: null,
        charge: null,
        charge_kana: null,
        address: null,
        phone_numbers: [{phone_number: null}],
        email_address: null,
        state: 10,
        likelihood: 10
      })
    },
    register() {
      this.errors = {}
      let company_id = this.company_id || 'new'

      if (!this.company_name) {
        this.errors.company_name = '施工主名を追加してください'
      }

      if (Object.keys(this.errors).length > 0) {
        return
      }

      this.openLoading()
      this.$http.post('/companies/' + company_id + '/register', {
        company_name: this.company_name,
        company_name_kana: this.company_name_kana,
        industry_type: this.selectedInsdustryType === null ? null : this.selectedInsdustryType.value,
        advertising_agency: this.advertising_agency,
        url: this.url,
        tags: this.selectedTags,
        note: this.note,
        shops: this.shops,
      }).then(response => {
        this.closeLoading()
        this.$buefy.toast.open(`登録が完了しました`)
        this.company_id = Number(response.data.company_id)
        this.$router.push({name: 'CompaniesDetail', params: {company_id: this.company_id}})
      }).catch(error => {
        console.log(error)
        this.closeLoading()
      })
    },
    checkPhoneNumber(shop_id, shopIdx, phoneIdx) {
      const phone_number = this.shops[shopIdx]['phone_numbers'][phoneIdx].phone_number
      this.$http.get('/check/phone-number', {
        params: {
          phone_number: phone_number,
          shop_id: shop_id,
        }
      }).then(response => {
        const result = response.data.result
        if (result) {
          this.$buefy.toast.open({
            duration: 10000,
            message: `電話番号 ${phone_number} は既に登録されています。<br>このまま登録できますが会社や店舗が重複しないか確認することをお勧め致します。`,
            type: 'is-warning',
          })
        }
      }).catch(error => {
        console.log(error)
        this.closeLoading()
      })
    },
    customLabel({key}) {
      return this.tags[key]
    },
  },
}
</script>

<style scoped>
#add-phone-number-input {
  cursor: pointer;
  display: flex;
  align-items: center;
}

#add-shop-block {
  cursor: pointer;
}

.shop_block {
  margin: 2rem 0;
}

hr {
  background-color: lightgray;
}

</style>
